<div class="row">
  <div class="container testimonials-section">
    <div class="profile-item">
      <div class="row ngx-slick-carousel-container">
        <ngx-slick-carousel class="testimonials-slider" [config]="slickCarouselConfig">
          <div ngxSlickItem class="col-lg-4 col-md-6 single-testimonial" *ngFor="let testimonial of testimonials">
            <div class="testimonial-card">
              <div class="testimonial-thumb">
                <img [src]="testimonial?.image" [alt]="testimonial.name">
              </div>
              <div class="testimonial-body">
                <p>{{testimonial.message}}</p>
                <h5>{{testimonial.name}}</h5>
                <span class="testimonial-role">{{testimonial.role}}</span>
              </div>
            </div>
          </div>
        </ngx-slick-carousel>
      </div>
    </div>
  </div>
</div>